document.addEventListener('DOMContentLoaded', function () {

  if (!customElements.get('viewport-video')) {

    class ViewportVideo extends HTMLElement {

      connectedCallback() {

        this.video = this.querySelector('video');
        if (!this.video) return;

        this.video.muted = true;
        this.video.setAttribute('playsinline', '');

        const observer = new IntersectionObserver(entries => {

          entries.forEach(entry => {

            if (entry.isIntersecting) {
              this.video.play().catch(() => {});
            } else {
              this.video.pause();
            }

          });

        }, { threshold: 0.3 });

        observer.observe(this);
      }
    }

    customElements.define('viewport-video', ViewportVideo);
  }

});